module.exports = __webpack_public_path__ + "307c3ce278f5a96dc2d37b253f946ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/netzbuehne04.jpg
// module id = 813
// module chunks = 0